export default __webpack_public_path__ + "static/media/tms-streamer-pro.2e49a017.webp";